import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=37be0ebb"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=37be0ebb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports